export default __webpack_public_path__ + "ea25d8a3eae27fa362f8a9c9549d737b.jpg";